import { useParams, Link } from "react-router-dom";
import { hotels } from "../data/hotels";
import "./Hotels.css";

export default function HotelDetail() {
  const { id } = useParams();
  const hotel = hotels.find((h) => h.id === id);

  if (!hotel) return <p>Hotel not found</p>;

  return (
    <section className="hotel-detail-card">
      <div className="detail-layout">
        <div className="detail-image-wrapper">
          <img src={hotel.image} alt={hotel.title} className="detail-image" />
        </div>
        <div className="detail-text">
          <h2>{hotel.title}</h2>
          <p className="location">📍 {hotel.location}</p>
          <p className="description">{hotel.longDescription}</p>
          <div className="hotel-buttons">
            <Link to="/hotels" className="btn-back">← Back to Hotels</Link>
            <a 
              href={`https://wa.me/255682837935?text=Hello,%20I%20would%20like%20to%20book%20a%20stay%20at%20${encodeURIComponent(hotel.title)}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-book"
            >
              Book Hotel
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
